import { format } from "date-fns";
import EventModal from "../EventModal";
import { PlanningEvent } from "../PlanningEvent";

export const PlanningRDVWeekView = ({
  events,
  timeSlots,
  handleClick,
  handleOpenModal,
  handleCloseModal,
  open,
  highligtedEvent,
  day_view,
  daysOfWeek,
  weekDates,
  height,
  events_colors,
  pack_short_dict,
  simplified_view,
  masterData,
  orgData,
  userData,
  selected_operators,
  onDelete,
  navigateWorkspace,
  workspaceData,
  getYPosition,
  timeToMinutes,
}) => {
  return (
    <>
      <div className=" relative  ">
        {events.length === 0 && (
          <div className="absolute h-[80vh] w-[70vw]  z-0  items-center flex justify-center left-20  p-6 rounded-2xl text-shadow_50  flex-col gap-2">
            <div className="text-h2 w-c400 text-center">
              Aucun créneau n'est disponible pour cette semaine
            </div>
            <div className="text-h3 text-shadow_25 w-c400 text-center">
              Utilisez les flêches pour naviguer entre les semaines
            </div>{" "}
          </div>
        )}
      </div>
      {day_view === null &&
        daysOfWeek.map((day, day_index) => (
          <div
            key={day_index}
            className="bg-transparent border-l-1 border-shadow_5  flex flex-col  w-1/5  font-light min-h-fit p-1 text-h4 text-black justify-center"
          >
            <div
              className=" gap-1 w-full h-c500 relative "
              style={{
                height: `${height}px`,
              }}
            >
              <div
                className="absolute w-full max-h-full "
                style={{
                  top: "6px",
                }}
              >
                {timeSlots.map((hour, timeindex) => (
                  <div
                    key={timeindex}
                    style={{
                      height: `${height * 0.0772}px`,
                    }}
                    className=" w-full border-t-1   border-shadow_5  select-none relative flex-col  opacity-100 font-light p-2 justify-start"
                  ></div>
                ))}{" "}
              </div>

              {events

                .filter(
                  (event) =>
                    (event.weekdate === day &&
                      (event.frequency || "") !== "daily") ||
                    event.frequency === "daily"
                )
                .filter((event) =>
                  event.exception_dates && event.frequency
                    ? !(event.exception_dates || []).includes(
                        format(weekDates[day_index], "dd/MM/yyyy")
                      )
                    : true
                )
                .filter((event) =>
                  selected_operators.includes("no_operator")
                    ? event.members_id?.length === 0
                    : selected_operators.includes(
                        event.members_id
                          ? event.members_id[0]
                            ? event.members_id[0]
                            : null
                          : null
                      ) || selected_operators.includes("all")
                )
                .sort((a, b) => a.start - b.start)

                .map((event, index) => {
                  return (
                    <div
                      key={index}
                      className="absolute w-full "
                      style={{
                        top: `${getYPosition(timeToMinutes(event.startTime))}rem`,
                        zIndex: `${open[event.id] ? "10" : highligtedEvent === event.id ? "5" : "1"}`,
                      }}
                    >
                      <EventModal
                        parsed_date={format(weekDates[day_index], "dd/MM/yyyy")}
                        event={event}
                        setEvent={() => {}}
                        setModalOpen={() => handleCloseModal(event.id)} // Pass close modal handler
                        orgData={orgData}
                        userData={userData}
                        onDelete={(e) => {
                          onDelete(e);
                        }}
                        onUpdate={() => {}}
                        open={open[event.id]}
                        setOpen={(e) => {
                          handleOpenModal(event.id);
                        }}
                        navigateWorkspace={navigateWorkspace}
                        workspaceData={workspaceData}
                      >
                        <PlanningEvent
                          event={event}
                          events_colors={events_colors}
                          pack_short_dict={pack_short_dict}
                          highligtedEvent={highligtedEvent}
                          height={height}
                          simplified_view={simplified_view}
                          masterData={masterData}
                          rdv={true}
                        ></PlanningEvent>
                      </EventModal>
                    </div>
                  );
                })}
            </div>
          </div>
        ))}
    </>
  );
};
